import { auth } from '../config/firebase-config';

const FUNCTION_URL =
  process.env.NODE_ENV === 'development' && process.env.REACT_APP_FIREBASE_EMULATOR_HOST
    ? `http://${process.env.REACT_APP_FIREBASE_EMULATOR_HOST}/nur-al-huda/us-central1/generateConversationTitle`
    : 'https://us-central1-nur-al-huda.cloudfunctions.net/generateConversationTitle';

/**
 * Generates a short conversation title from the first exchange.
 * @param {string} userMessage - First user message (truncated to 500 chars)
 * @param {string} assistantMessage - First assistant response (truncated to 500 chars)
 * @returns {Promise<string|null>} Generated title or null on failure
 */
export const generateTitle = async (userMessage, assistantMessage) => {
  const token = auth.currentUser ? await auth.currentUser.getIdToken() : null;

  const res = await fetch(FUNCTION_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({
      userMessage: (userMessage || '').substring(0, 500),
      assistantMessage: (assistantMessage || '').substring(0, 500),
    }),
  });

  if (!res.ok) {
    console.error('Title generation failed:', res.status);
    return null;
  }

  const data = await res.json();
  return data.title || null;
};
